module.exports = __webpack_public_path__ + "static/page-banner-salesmate-1e649b599fd14833bbb7e7c0f980fbdb.png";